module.exports = __webpack_public_path__ + "static/media/octorion-code.f6cd9bd5.svg";